function clickDownloadAnchor(href: string, filename: string, target: string = "_self") {
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.target = target;
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export async function downloadFile(url: string) {
  const filename = url.split("/").pop()?.split("?")[0] || "file";

  try {
    const resp = await fetch(url);
    const blob = await resp.blob();
    const blobUrl = URL.createObjectURL(blob);
    clickDownloadAnchor(blobUrl, filename, "_blank");
    URL.revokeObjectURL(blobUrl);
  } catch {
    clickDownloadAnchor(url, filename, "_blank");
  }
}

export function isInAppBrowser(): boolean {
  const IN_APP_BROWSER_TOKENS = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|FB4A/i;

  if (typeof navigator === "undefined") return false;
  return IN_APP_BROWSER_TOKENS.test(navigator.userAgent);
}

export function formatDuration(sec: number) {
  const total = Math.round(sec);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return m > 0 ? `${m}m ${s}s` : `${s}s`;
}
